<template>
  <!-- Modal Component -->
  <b-modal v-b-modal.modalCategoryGroupIncidence id="modalCategoryGroupIncidence" ref="modalCategoryGroupIncidence" centered
    title="Escull un nou tipus d'incidència">
    <b-container class="text-center">
      <CategoryGroupIncidenceSelects
        @changeIncidence="childVal => {  this.newIncidence = childVal.incidence }"/>
    </b-container>
    <div slot="modal-footer" class="w-100">
      <b-btn class="float-right" variant="primary" @click.prevent="reassign()">
        <font-awesome-icon :icon="['fas', 'check']"/>
        Escollir
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
import CategoryGroupIncidenceSelects from '@/components/CategoryGroupIncidenceSelects'

export default {
  components: {
    CategoryGroupIncidenceSelects
  },
  props: {
    ticket: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      newIncidence: null
    }
  },
  methods: {
    reassign () {
      var data = {
        ticket_id: this.ticket.id,
        codi_xarxa: this.$store.getters.getUser.id,
        incidence: this.newIncidence
      }
      if (this.isNullOrUndefined(data.incidence)) {
        this.notifyError('Falta informació', 'Has d\'escollir un nou tipus d\'incidència')
      } else {
        this.$store.dispatch('managerReassignTicket', data)
        this.$refs.modalCategoryGroupIncidence.hide()
      }
      this.newIncidence = null
    }
  }
}
</script>

<style scoped>
</style>
